// extracted by mini-css-extract-plugin
export default {"previewContainer":"ProductLogo_previewContainer__QmmZM","preview":"ProductLogo_preview__9eXgS","badge":"ProductLogo_badge__3Q+NW"};